"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("../../assets/PPTextArea.css");
var PPIconLink_1 = require("../PPIconLink");
var PPTextArea = function (_props) {
    var width = _props.width, error = _props.error, decoration = _props.decoration, functions = _props.functions, autoheight = _props.autoheight, props = __rest(_props, ["width", "error", "decoration", "functions", "autoheight"]);
    var _a = (0, react_1.useState)(false), active = _a[0], setActive = _a[1];
    var _b = (0, react_1.useState)(props.rows ? "auto" : 40), height = _b[0], setHeight = _b[1];
    var onChange = function (event) {
        (!props.disabled && !props.readOnly) && props.onChange &&
            props.onChange(event);
    };
    return (react_1.default.createElement("div", { className: "pp-textarea".concat(props.disabled ? " disabled" : "").concat(props.readOnly ? " readonly" : ""), style: { width: width || undefined } },
        props.title &&
            react_1.default.createElement("div", { className: "title" }, props.title),
        react_1.default.createElement("div", { className: "field".concat((!props.disabled && !props.readOnly) && props.required ? ' required' : '').concat((error === null || error === void 0 ? void 0 : error.show) ? ' error' : '').concat(active ? " active" : ""), style: { height: height } },
            decoration &&
                react_1.default.createElement("div", { className: "decoration" }, decoration),
            react_1.default.createElement("textarea", __assign({}, props, { onFocus: function () { return setActive(true); }, onBlur: function () { return setActive(false); }, className: "value", onInput: function (event) {
                    autoheight &&
                        setHeight(event.target.scrollHeight + 18);
                } })),
            react_1.default.createElement("div", { className: "icons" },
                !(props.required || props.readOnly || props.disabled) && props.value &&
                    react_1.default.createElement("i", { className: "ppi ppi-x", onClick: function () { return (!props.disabled || !props.readOnly) && onChange({ target: { name: props.name, value: "" } }); } }), functions === null || functions === void 0 ? void 0 :
                functions.map(function (f, i) {
                    return react_1.default.createElement(PPIconLink_1.PPIconLink, { key: i, tooltipPosition: "right", size: "small", icon: f.icon, tooltip: f.tooltip, onClick: f.onClick, disabled: f.disabled || props.disabled || props.readOnly });
                }))),
        (error === null || error === void 0 ? void 0 : error.show) &&
            react_1.default.createElement("div", { className: "help" },
                react_1.default.createElement("i", { className: "ppi ppi-chevron-up-alt" }),
                react_1.default.createElement("div", { className: "main" },
                    react_1.default.createElement("div", { className: "content" }, error.help)))));
};
exports.default = PPTextArea;
